// Auto-extracted from LangContext.jsx — single source of truth for EN translations.
// Edit this file to update wording. Keys must stay in sync across active locales (see ACTIVE_LANGS).
/* eslint-disable */
const dict = {
  app_tagline: 'The future of basketball playbooks',
  nav_dashboard: 'Dashboard', nav_playbook: 'Playbook', nav_editor: 'Editor', nav_roster: 'Roster',
  nav_ai: 'AI Coach', nav_live: 'Live Game', nav_simulator: 'Simulator', nav_academy: 'Academy',
  nav_invitations: 'Invitations', nav_admin: 'Admin', nav_pricing: 'Plans',
  nav_manual: 'Manual',
  nav_marketplace: 'Marketplace', nav_profile: 'My Profile', nav_notifications: 'Notifications', nav_achievements: 'Achievements',
  nav_tactile: 'Tactile', mob_market: 'Market', mob_ia: 'AI',
  login: 'Login', register: 'Sign up', logout: 'Logout', email: 'Email', password: 'Password',
  name: 'Name', role: 'Role', coach: 'Coach', player: 'Player', or: 'or',
  welcome_back: 'Welcome back', create_account: 'Create account',
  invite_share_text: 'Hi {name}, we are inviting you to join the team "{team}" on PlayMaster IA. Sign up here: {url}',
  invite_share_text_generic: 'We are inviting you to join the team "{team}" on PlayMaster IA. Sign up here: {url}',
  invite_share_text_no_team: 'I am inviting you to join my team on PlayMaster IA. Sign up here: {url}',
  invite_share_title: 'Invitation · {name}',
  invite_share_native_text: 'Hi {name}, we are inviting you to join the team "{team}" on PlayMaster IA.',
  register_invite_coach_team: 'Coach {coach} is inviting you to join the team {team}.',
  register_invite_coach_no_team: 'Coach {coach} is inviting you to create your account.',
  register_show_password: 'Show password', register_hide_password: 'Hide password',
  register_your_username: 'Your username',
  register_save_credentials: 'Save this username and your password so you can log back in. Taking you to your playbook...',
  register_terms_intro: 'By signing up you agree to our',
  register_terms_link: 'Terms',
  register_terms_and: 'and',
  register_privacy_link: 'Privacy Policy',
  register_google_locale: 'en',
  plays: 'Plays', total_plays: 'Total plays', active_players: 'Active players',
  success_rate: 'Success rate', ai_sessions: 'AI sessions',
  search: 'Search play...', all_categories: 'All categories',
  cat_man: 'vs Man', cat_zone: 'vs Zone', cat_ato: 'ATO', cat_blob: 'BLOB', cat_slob: 'SLOB', cat_endgame: 'End of game',
  create_play: 'Create play', save: 'Save', cancel: 'Cancel', edit: 'Edit', delete: 'Delete',
  upload_photo: 'Upload photo', add_player: 'Add player',
  height: 'Height', weight: 'Weight', number: 'Number', position: 'Position',
  dominant_hand: 'Dominant hand', strength: 'Strength', weakness: 'Weakness', ideal_role: 'Ideal role',
  generate_link: 'Generate invite link', copy_link: 'Copy link', copied: 'Copied',
  chat_placeholder: 'Ask the AI about tactics, plays or players...',
  send: 'Send', generate_play: 'Generate play', recommend_plays: 'Recommend plays',
  predict_success: 'Predict success',
  defense: 'Defense', moment: 'Moment', recommend: 'Recommend',
  step: 'Step', steps: 'steps', play: 'Play', stop: 'Stop',
  pause: 'Pause', prev: 'Prev', next: 'Next', loop_label: 'Loop', off_label: 'Off',
  worked: '✔ Worked', didnt_work: "✕ Didn't work",
  coach_premium: 'Coach Premium', player_premium: 'Player Premium', academy: 'Academy',
  plan_premium_monthly: 'Premium Monthly', plan_premium_annual: 'Premium Annual',
  plan_starter: 'Starter', plan_pro_coach: 'Pro Coach',
  plan_best_value: 'Best value', plan_starter_addons_hint: 'Add-ons available: IQ Score, Game IQ Simulator, Personal AI Coach',
  feat_everything_starter: 'Everything in Starter',
  feat_everything_unlimited: 'Everything unlimited',
  feat_150_ai: '150 AI sessions / mo',
  feat_30_players: 'Up to 30 players',
  feat_includes_iq_score: 'Includes IQ Score',
  feat_includes_iq_full_suite: 'Includes IQ Score + Game IQ Simulator + Personal AI Coach',
  addons_eyebrow: 'À LA CARTE',
  addons_title: 'Monthly add-ons',
  addons_subtitle: 'Unlock single features without upgrading. Billed on top of your plan.',
  addon_iq_score_label: 'IQ Score',
  addon_iq_score_desc: 'Game-intelligence tracker with rosters and saved stats.',
  addon_iq_simulator_label: 'Game IQ Simulator',
  addon_iq_simulator_desc: '50+ real scenarios graded by AI. Challenges and public leaderboard.',
  addon_ai_coach_label: 'Personal AI Coach',
  addon_ai_coach_desc: 'Personal AI coach that reviews your plays and proposes corrections.',
  addon_buy: 'Activate add-on',
  addon_renew: 'Renew',
  addon_included: 'Included in your plan',
  /* IQ Score - multi-select picker (EN catch-up) */
  iqs_add_selected: 'Add selected',
  iqs_selected_count: '{n} selected',
  iqs_no_selection: 'Tap players to select them',
  /* Shot Analyzer */
  nav_shot_analyzer: 'Shot Analyzer',
  addon_shot_analyzer_label: 'Shot Analyzer',
  addon_shot_analyzer_desc: 'AI shot-mechanics analysis with ghost silhouette and personalised coaching report.',
  sa_eyebrow: 'AI shot analysis',
  sa_title: 'Shot Analyzer',
  sa_subtitle: 'Record a shot, align with the ghost silhouette, and AI grades your mechanics frame by frame. 100% on-device.',
  sa_manual_button: 'Manual',
  sa_manual_eyebrow: 'Before you start',
  sa_manual_title: 'User manual',
  sa_manual_intro: 'For the analysis to be accurate, follow these guidelines every time you use Shot Analyzer:',
  sa_manual_accept: 'I understand and accept',
  sa_manual_requirements_title: 'Minimum requirements',
  sa_manual_requirements_body: 'Phone or tablet with camera, even lighting, clear background, and camera permission. The player and (for distance analysis) the rim must be visible.',
  sa_manual_disclaimer: 'Approximate analysis for technical feedback. Not a certified biomechanics tool.',
  sa_man_camera_title: 'Stable camera',
  sa_man_camera_body: 'Place the phone on a tripod or stable surface. Waist height, perpendicular to the player.',
  sa_man_distance_title: 'Distance ~3m',
  sa_man_distance_body: 'The player must fit fully on screen (feet to hands). Adjust until the body is fully visible.',
  sa_man_light_title: 'Good lighting',
  sa_man_light_body: 'Even light, no backlighting. Do not record against windows or direct light sources.',
  sa_man_align_title: 'Ghost silhouette',
  sa_man_align_body: 'When you start you will see a gold silhouette. Match its posture. When you reach 80%+, recording starts automatically.',
  sa_man_good_title: 'Good example',
  sa_man_good_body: 'Player centered, perpendicular to camera, clear background, even light, contrasting clothing.',
  sa_man_bad_title: 'Avoid',
  sa_man_bad_body: 'Shaky camera, player cropped on screen, background the same colour as clothing, strong side lighting.',
  sa_camera_denied: 'Camera access denied. Enable it in your browser settings.',
  sa_not_enough_frames: 'Shot too short. Try again and stay in frame for the full motion.',
  sa_save_fail: 'Could not save the attempt',
  sa_status_loading_model: 'Loading AI model...',
  sa_status_idle: 'Ready to start',
  sa_status_align: 'Align with the silhouette',
  sa_status_align_short: 'Align your body',
  sa_align_headline: 'Align with the silhouette.',
  sa_align_target: 'Target',
  sa_status_capturing: 'Capturing your shot',
  sa_status_analyzing: 'Analysing mechanics',
  sa_status_done: 'Done',
  sa_target_match: 'Target',
  sa_start: 'Start analysis',
  sa_upload_video: 'Upload video',
  sa_video_load_fail: 'Could not open that video',
  sa_video_pick_shooter: 'Tap the shooter or leave it on auto (ball)',
  sa_video_analyze: 'Analyze shot',
  sa_status_video_scrub: 'Video · pick the shooter',
  sa_shooter_locked: 'Shooter selected',
  sa_shooter_ready: 'ready',
  sa_players_detected: 'players',
  sa_new_attempt: 'New attempt',
  sa_model_error: 'Model load error',
  sa_overall_score: 'Overall score',
  sa_metrics: 'Metrics',
  sa_errors: 'Detected errors',
  sa_ai_report: 'AI coach report',
  sa_generating_report: 'Generating report...',
  sa_no_report: 'No report available',
  sa_history: 'Recent attempts',
  sa_shot_side: 'Shooting arm',
  sa_side_right: 'Right',
  sa_side_left: 'Left',
  sa_disclaimer: 'Approximate analysis for technical feedback. Not a certified biomechanics tool.',
  sa_gated_title: 'Shot Analyzer is an add-on',
  sa_gated_body: 'Unlock AI shot-mechanics analysis for $6.99/mo (included in Premium Annual).',
  sa_gated_cta: 'See plans',
  sa_m_elbow: 'Elbow angle (release)',
  sa_m_knee: 'Knee bend (dip)',
  sa_m_release_h: 'Release height',
  sa_m_balance: 'Balance',
  sa_m_align: 'Shoulder alignment',
  sa_m_rhythm: 'Rhythm / fluidity',
  sa_m_leg_drive: 'Leg drive',
  sa_m_dip_ms: 'Dip → release time',
  sa_m_follow_ms: 'Follow-through',
  sa_m_release_angle: 'Release angle',
  sa_m_apex: 'Arc height',
  sa_m_arc_quality: 'Arc quality',
  sa_m_flight_time: 'Flight time',
  sa_m_rim_distance: 'Distance to rim',
  sa_m_rim_made: 'Rim hit',
  sa_rim_yes: 'Yes',
  sa_rim_no: 'No',
  sa_ball_section: 'Ball trajectory',
  sa_no_ball: 'Ball not detected in this take',
  sa_tip_orange: 'Use an orange ball under good lighting so the tracker can lock on.',
  sa_rim_calibrate: 'Calibrate rim',
  sa_rim_tap_hint: 'Tap the rim centre on screen',
  sa_rim_set: 'Rim set',
  sa_rim_reset: 'Reset rim',
  sa_rim_auto: 'Auto',
  sa_rim_auto_hint: 'Detect the rim automatically with computer vision',
  sa_rim_auto_ok: 'Rim detected',
  sa_rim_auto_fail: 'Could not detect the rim — tap on screen',
  sa_camera_needed: 'Turn the camera on first',
  sa_show_trajectory: 'Show trajectory',
  sa_hide_trajectory: 'Hide trajectory',
  sa_err_open_elbow: 'Open elbow',
  sa_err_low_release: 'Low release',
  sa_err_no_legs: 'No leg drive',
  sa_err_lean_forward: 'Leaning forward',
  sa_err_lean_backward: 'Leaning backward',
  sa_err_broken_rhythm: 'Broken rhythm',
  sa_err_pushed_shot: 'Pushed shot',
  sa_err_lack_of_fluidity: 'Lacks fluidity',
  sa_err_misalignment: 'Misalignment',
  sa_err_flat_arc: 'Flat arc',
  sa_err_rainbow_arc: 'Rainbow arc',
  sa_err_short_arc: 'Short arc',
  sa_download_report: 'Download PDF report',
  sa_exporting: 'Generating PDF...',
  sa_export_fail: 'Could not generate the PDF',
  sa_pdf_title: 'Shot analysis report',
  sa_pdf_player: 'Player',
  sa_pdf_attempts_logged: 'Attempts logged',
  sa_pdf_personal_best: 'Personal best',
  sa_pdf_avg: 'Average',
  sa_pdf_errors_found: 'Errors detected',
  sa_pdf_vs_last: 'vs last',
  sa_pdf_no_errors: 'No errors detected on this take. Excellent execution.',
  sa_pdf_progress: 'Progression (last 10 takes)',
  sa_pdf_progress_caption: 'Overall score per attempt. Y-axis: 0–100.',
  sa_pdf_recommendations: 'Recommendations to improve',
  sa_rec_elbow: 'Tuck the elbow: bring the elbow to 90° at release and keep it under the ball. Drill: 50 form shots one meter from a wall.',
  sa_rec_release: 'Raise the set point: release above the forehead, not the chest. Drill: 3×10 mirror reps focusing on a high release.',
  sa_rec_legs: 'Use your legs: deepen the dip to ~130° knee bend to transfer energy. Drill: 4×8 chair shots — sit, stand and shoot in one motion.',
  sa_rec_balance: 'Stay centered on the jump: body perpendicular to the floor at release, no forward/backward drift. Drill: stationary shots holding the follow-through for 3s.',
  sa_rec_rhythm: 'Work on fluidity: a single continuous motion dip→release, no pause. Drill: 3×10 shots counting "1 (dip), 2 (release)".',
  sa_rec_follow: 'Hold the follow-through for at least 1 second pointing at the rim. Drill: 2×15 form shots, freeze 2 seconds each.',
  sa_rec_align: 'Square shoulders and hips to the rim before going up. Drill: 10 shots checking feet+hips first, then shoot.',
  sa_rec_keep: 'Excellent execution. Reinforce the pattern with volume.',
  sa_rec_volume: 'Hit 3×25 shots from the same spot this week to lock in muscle memory.',
  sa_rec_record: 'Record yourself again in 48h and compare: same angle, same framing.',
  nav_feedback: 'Feedback',
  fb_eyebrow: 'Your voice matters',
  fb_title: 'Send feedback',
  fb_subtitle: 'Tell us what we can improve, what you would love to see, or report a bug. Every message reaches our team.',
  fb_category: 'Category',
  fb_cat_bug: 'Bug', fb_cat_bug_desc: "Something doesn't work as expected",
  fb_cat_idea: 'Idea', fb_cat_idea_desc: 'A new feature or improvement',
  fb_cat_praise: 'Praise', fb_cat_praise_desc: 'Something you loved',
  fb_cat_other: 'Other', fb_cat_other_desc: 'Any other comment',
  fb_field_title: 'Title',
  fb_title_placeholder: 'E.g. "Download button does not respond on Safari"',
  fb_field_body: 'Details',
  fb_body_placeholder: 'Tell us in detail what happened, what you expected, what device, etc.',
  fb_field_rating: 'Overall experience (optional)',
  fb_send: 'Send feedback', fb_sending: 'Sending...',
  fb_send_fail: 'Could not send the feedback',
  fb_validation: 'Fill in the title (min 3) and details (min 10 chars).',
  fb_success_title: 'Thank you! We got your feedback.',
  fb_success_body: 'We will review it within 48 hours.',
  fb_send_another: 'Send another',
  fb_disclaimer: 'Your feedback is tied to your account so we can follow up. We never share it with third parties.',
  afb_nav: 'Feedback Inbox',
  afb_eyebrow: 'Internal triage',
  afb_title: 'Feedback Inbox',
  afb_subtitle: 'Review, tag and reply to the messages users send us.',
  afb_all: 'All', afb_status: 'Status', afb_category: 'Category',
  afb_status_new: 'New', afb_status_triaged: 'Triaged', afb_status_done: 'Done',
  afb_status_changed: 'Status updated', afb_set_status: 'Set status',
  afb_stat_total: 'Total', afb_stat_new: 'New', afb_stat_triaged: 'Triaged', afb_stat_done: 'Done',
  afb_empty: 'No feedback for these filters.',
  afb_replies: 'Previous replies',
  afb_reply_label: 'Reply to the user by email',
  afb_reply_placeholder: 'Write your reply. It will be emailed to the user and shown in-app.',
  afb_reply_send: 'Send reply', afb_sending: 'Sending...',
  afb_reply_sent: 'Reply sent to {email}',
  afb_reply_fail: 'Could not send the reply',
  afb_reply_validation: 'Write at least 10 characters.',
  sa_send_to_coach: 'Email report to coach',
  sa_sending: 'Sending...',
  sa_send_ok: 'Report sent to {email}',
  sa_send_fail: 'Could not send the email',
  sa_send_wait_save: 'Wait for the attempt to save (a few seconds).',
  sa_inbox_title: 'Received analyses',
  sa_inbox_errors: 'errors',
  sa_voice_reply: 'Voice reply',
  sa_voice_listen: 'Listen',
  sa_voice_played: 'Play',
  sa_voice_from_coach: 'Coach note',
  sa_voice_play_fail: 'Could not play the audio',
  sa_voice_modal_eyebrow: 'Voice note',
  sa_voice_modal_title: 'Record a reply',
  sa_voice_for: 'For',
  sa_voice_record: 'Record',
  sa_voice_pause: 'Pause',
  sa_voice_resume: 'Resume',
  sa_voice_stop: 'Stop',
  sa_voice_discard: 'Discard',
  sa_voice_send: 'Send to player',
  sa_voice_sending: 'Sending...',
  sa_voice_sent: 'Voice note sent to the player',
  sa_voice_send_fail: 'Could not send the voice note',
  sa_voice_mic_denied: 'Microphone access denied. Enable it in your browser.',
  sa_voice_remaining: '{n}s left · 60s max',
  sa_voice_max: 'Max {n}s',
  close: 'Close',
  month: 'month', year: 'year', subscribe: 'Subscribe',
  /* Manual */
  manual_h1: 'Instruction Manual',
  manual_subtitle: 'Complete guide to every feature of PlayMaster IA. Updates automatically with each new version.',
  manual_version: 'Version',
  manual_search_placeholder: 'Search a feature…',
  /* Marketplace */
  marketplace_back: 'Back to Marketplace',
  marketplace_elite_coach: 'Elite Coach',
  marketplace_about_play: 'About this play',
  marketplace_purchase_success: 'Purchase successful! Play added to your playbook',
  marketplace_purchase_error: 'Purchase error',
  marketplace_listing_not_found: 'Listing not found.',
  marketplace_purchased: 'Purchased',
  marketplace_buy_cta: 'Buy and add to my playbook',
  marketplace_coaches_own: 'coaches already own this play.',
  /* Roster */
  roster_invite_ready: 'Invitation ready — tap Share',
  manual_no_results: 'No sections found for "{q}".',
  /* IQ Simulator landing (public) */
  iq_info_eyebrow: 'New · Premium Annual feature',
  iq_info_h1_a: 'Train basketball', iq_info_h1_b: 'IQ like a pro',
  iq_info_subtitle: "The world's first AI Basketball IQ Simulator — train real-game decisions, not isolated drills.",
  iq_info_para: 'Game IQ Simulator presents real basketball scenarios — pick-and-roll coverages, last-possession reads, transition defense. Pick the smartest decision, get instant AI coaching feedback, and watch your IQ score grow. Built for youth, high school, AAU, academies and pro-level players.',
  iq_info_cta_primary: 'Start training your IQ', iq_info_cta_pricing: 'See plans',
  iq_info_video_coming: 'Live demo video coming soon', iq_info_try_live: 'Try it live — sign up free',
  iq_info_video_fallback: 'Your browser does not support inline video. Sign up to try the simulator live.',
  iq_info_pillars_eyebrow: 'Why Game IQ matters',
  iq_info_pillars_h2: 'Stop drilling. Start deciding.',
  iq_info_pillars_desc: 'Elite players are made of decisions. PlayMaster IA brings the decision-making rep — the rep that scouting reports call "basketball IQ" — into a structured, repeatable training format.',
  iq_info_p1_t: 'Real-game scenarios', iq_info_p1_d: 'Pick-and-roll vs Drop / Hedge / Switch · Zone offense · Last possession · Transition · Star ISO defense — situations every competitive player faces by U14.',
  iq_info_p2_t: 'Instant AI coaching', iq_info_p2_d: 'Each decision is evaluated by Claude AI — you get specific feedback in your language, not generic praise. Read the explanation, fix the mistake.',
  iq_info_p3_t: 'Track your IQ Score', iq_info_p3_d: 'Build a measurable score across categories. Climb the rank ladder from Walk-on to Floor General. Coaches see player progress in their dashboard.',
  iq_info_how_eyebrow: 'How it works', iq_info_how_h2: '3 steps to a smarter player',
  iq_info_s1_t: 'Pick a scenario', iq_info_s1_d: 'Choose Offensive, Defensive — soon Complete Mode with score, clock and fouls.',
  iq_info_s2_t: 'Decide in seconds', iq_info_s2_d: 'Read the court, pick the best option from 3 choices. Reaction time counts.',
  iq_info_s3_t: 'Get AI feedback', iq_info_s3_d: 'Claude AI explains why your read worked — or what the optimal call was.',
  iq_info_who_eyebrow: 'Built for', iq_info_who_h2: 'Coaches, players and academies that take IQ seriously',
  iq_info_who_list: 'Youth basketball coaches|High school programs|AAU clubs|Basketball academies|Pro & semi-pro player development|Individual players age 12+',
  iq_info_inside_title: 'Inside the Annual Premium plan',
  iq_info_inside_desc: 'Game IQ Simulator is included in the Annual Premium plan — together with the full playbook, AI Coach, multi-team management, academy mode and priority support.',
  iq_info_final_h2: 'Make your next basketball decision a smart one',
  iq_info_final_para: 'Join the coaches and players already training their basketball IQ with PlayMaster IA.',
  back_home: 'Back to home', signup: 'Sign Up',
  /* Misc */
  processing: 'Processing...',
  feat_iq_simulator: 'Game IQ Simulator',
  nav_iq_simulator: 'Game IQ Simulator',
  nav_iq_score: 'IQ Score',
  iq_module_label: 'Game IQ Simulator',
  iq_h1: 'Game IQ Simulator',
  iq_subtitle: 'Train your basketball IQ with real-game scenarios. Every decision is evaluated by an AI coach.',
  iq_total_score: 'IQ Score',
  iq_accuracy: 'Accuracy',
  iq_rank: 'Rank',
  iq_avg_reaction: 'Avg reaction',
  iq_cat_offensive: 'Offensive',
  iq_cat_defensive: 'Defensive',
  iq_open_scenario: 'Open scenario',
  iq_what_do_you_do: 'What do you do?',
  iq_reaction_tracking: 'Reaction time tracking…',
  iq_evaluating: 'AI evaluating your decision…',
  iq_back_to_hub: 'Back to simulator',
  iq_optimal: 'Optimal read',
  iq_suboptimal: 'Not the best read',
  iq_optimal_was: 'The optimal pick was',
  iq_tactical_explanation: 'Tactical explanation',
  iq_what_team_should: 'What the team should do',
  iq_ai_coach: 'AI Coach',
  iq_try_another: 'Try another scenario',
  iq_no_scenarios: 'No scenarios in this category yet.',
  iq_premium_only: 'Annual Premium only',
  iq_premium_pitch: 'Game IQ Simulator is included in the Annual Premium plan ($249.99/year) together with all premium perks. The monthly plan does not include this feature.',
  iq_premium_required: 'Annual Premium plan required.',
  iq_upgrade_cta: 'See plans',
  // Phase 2
  iq_cat_complete: 'Complete',
  iq_leaderboard: 'Leaderboard',
  iq_tts_on: 'Enable narration',
  iq_tts_off: 'Mute narration',
  iq_tts_label_on: 'Narration ON',
  iq_tts_label_off: 'Narration OFF',
  iq_gs_quarter: 'Quarter',
  iq_gs_clock: 'Clock',
  iq_gs_score: 'Score',
  iq_gs_fouls: 'Fouls',
  iq_gs_possession: 'Possession',
  iq_gs_ours: 'Ours',
  iq_gs_theirs: 'Theirs',
  iq_gs_bonus: 'You are in bonus — every defensive foul puts the opponent at the line.',
  iq_lb_all: 'All',
  iq_lb_empty: 'No decisions logged yet. Start a scenario to enter the ranking.',
  iq_lb_player: 'Player',
  iq_lb_score: 'IQ',
  iq_lb_attempts: 'Decisions',
  iq_lb_acc: 'Acc.',
  iq_lb_you: 'YOU',
  // Challenge Mode
  iqc_module_label: 'Challenge Mode',
  iqc_eyebrow: 'Game IQ Challenge',
  iqc_create_h: 'Create challenge',
  iqc_create_title_label: 'Challenge title',
  iqc_create_title_placeholder: 'e.g.: Clutch reads — U17',
  iqc_create_submit: 'Create challenge',
  iqc_create_success: 'Challenge created!',
  iqc_create_success_sub: 'Share this link with your players. Anyone with the link can take the challenge.',
  iqc_cta_h: 'Challenge your players',
  iqc_cta_sub: 'Build a 5-scenario set and share it via WhatsApp. The challenge leaderboard updates automatically.',
  iqc_cta_btn: 'Create challenge',
  iqc_my_h: 'My challenges',
  iqc_attempts: 'attempts',
  iqc_created_by: 'Created by',
  iqc_take_challenge: 'Take the challenge',
  iqc_login_to_take: 'Log in to take the challenge',
  iqc_upgrade_to_take: 'Go Premium to take it',
  iqc_how_h: 'How it works',
  iqc_how_1: '5 back-to-back scenarios — reaction time counts on each.',
  iqc_how_2: 'Your total score lands on the challenge leaderboard.',
  iqc_how_3: 'Share the link on WhatsApp and watch who beats your score.',
  iqc_scenario: 'Scenario',
  iqc_total_so_far: 'Running total',
  iqc_complete_eyebrow: 'Challenge complete',
  iqc_complete_h1: 'You did it!',
  iqc_summary_total: 'Total IQ',
  iqc_summary_correct: 'Correct',
  iqc_summary_accuracy: 'Accuracy',
  iqc_take_again: 'Try again',
  iqc_share_my_result: 'My score on this challenge',
  iqc_leaderboard_h: 'Challenge top scores',
  iqc_max_5: 'Maximum 5 scenarios per challenge.',
  iqc_share_default_title: 'Take my PlayMaster IA Challenge',
  iqc_share_default_text: "I challenged you on PlayMaster IA — {title}. Are you in?",
  iqc_not_found_h1: 'Challenge not found',
  iqc_not_found_body: 'The link may have expired or the code is incorrect.',
  back_to_dashboard: 'Back to Dashboard',
  iq_info_weekly_eyebrow: 'Hot this week',
  iq_info_alltime_eyebrow: 'Most played all-time',
  iq_info_weekly_h: 'Top Challenges',
  iq_info_weekly_sub: 'Live ranking of the most-played coach-made challenges. Tap any code to take it — no signup needed to preview.',
  iq_info_weekly_code: 'Code',
  iq_info_weekly_title: 'Challenge',
  iq_info_weekly_runs: 'This week',
  iq_info_weekly_plays: 'Plays',
  /* IQ Score (live in-practice tracker) */
  iqs_eyebrow: 'Official game-intelligence tracker',
  iqs_title: 'IQ Score',
  iqs_subtitle: 'Live scoreboard for smart basketball. Rewards collective reads, not just buckets. Tap an action every time your team reads the game well — first to the target wins.',
  iqs_mode: 'Mode',
  iqs_target: 'Target',
  iqs_mode_active: 'Mode',
  iqs_undo: 'Undo',
  iqs_reset: 'Reset',
  iqs_team: 'Team',
  iqs_team_red: 'Red',
  iqs_team_black: 'Black',
  iqs_impact_plays: 'Impact plays',
  iqs_winner: 'Winner',
  iqs_target_reached: 'reached',
  iqs_new_game: 'New game',
  iqs_total_actions: 'Total actions',
  iqs_leader: 'Currently leading',
  iqs_balance: 'Game balance',
  iqs_rules_title: 'Rules & scoring',
  iqs_rules_basic: 'Assist, rebound, block, steal and screen = 1 point. Full Pick & Roll: 1.5. Direct bucket without prior action: 0.5.',
  iqs_rules_combos: 'Impact plays (offensive rebound + bucket, block + pass + bucket, etc.) award more than the sum of the parts — they reward chained reads.',
  iqs_rules_target: 'Set the target (12, 20 or 21) and the mode (2v2 → 5v5). First team to reach it wins.',
  iqs_rules_purpose: 'Built so coaches and bench players learn by observing. Every tap is a read.',
  /* IQ Score - actions */
  iqs_a_assist: 'Assist',
  iqs_a_rebound: 'Rebound',
  iqs_a_block: 'Block',
  iqs_a_steal: 'Steal',
  iqs_a_screen: 'Screen',
  iqs_a_pnr: 'Pick & Roll',
  iqs_a_bucket: 'Bucket',
  /* IQ Score - combos */
  iqs_c_oreb_score: 'Off. reb + bucket',
  iqs_c_block_pass_bucket: 'Block + pass + bucket',
  iqs_c_steal_layup: 'Steal + layup',
  iqs_c_screen_pass_shot: 'Screen + pass + shot',
  /* IQ Score - roster & save */
  iqs_pick_for: 'Pick player for',
  iqs_add_player: 'Add player',
  iqs_no_roster: 'Your roster is empty. Go to Roster to add players.',
  iqs_no_players_left: 'All available players are already assigned.',
  iqs_label_placeholder: 'Label (optional): e.g. "vs JV Friday 2/21"',
  iqs_save_game: 'Save game',
  iqs_save_snapshot: 'Save snapshot',
  iqs_saving: 'Saving...',
  iqs_save_ok: 'Game saved',
  iqs_save_fail: 'Could not save the game',
  iqs_save_empty: 'Log at least one action before saving',
  iqs_stats_title: 'Game statistics',
  iqs_breakdown: 'Breakdown',
  iqs_history: 'Recent history',
  hello: 'Hi', loading: 'Loading...', view_all: 'View all', back: 'Back', close: 'Close', confirm: 'Confirm',
  language: 'Language', settings: 'Settings', not_found: 'Not found',
  top_plays: 'Top plays by success rate', distribution: 'Distribution', open_ai_coach: 'Open AI Coach',
  my_roster: 'My roster', my_publications: 'My Listings', no_plays_yet: "You haven't created any plays yet",
  no_invitations_yet: "You haven't generated invitations yet", go_to: 'Go to', go_to_editor: 'Go to the Editor',
  dashboard_subtitle: 'Your team control panel', greeting_morning: 'Good morning',
  privacy_policy: 'Privacy Policy', terms_of_service: 'Terms of Service',
  error_generic: 'Error', invalid_credentials: 'Invalid credentials',
  have_account: 'Already have an account?', no_account: "Don't have an account?",
  invites_subtitle: 'Short branded links with clicks & sign-ups analytics.',
  invite_label: 'Label', invite_label_placeholder: 'Main team',
  invite_custom_slug: 'Custom slug (optional)',
  voice: 'Voice', muted: 'Mute',
  voice_on_hint: 'Narration on (click to mute)',
  voice_off_hint: 'Turn voice narration on',
  loop_on_hint: 'Loop on',
  loop_off_hint: 'Loop off',
  translating: 'Translating...',
  show_as: 'Show as:', photo: 'Photo', initials: 'Initials',
  description_label: 'Description', works_against: 'Works against',
  listen_narration: 'Listen narration', tactical_simulator: 'Tactical Simulator',
  ai_prediction: 'AI Prediction', export_share: 'Export & share',
  image_label: 'Image', share_whatsapp_btn: 'Share via WhatsApp', generating_dots: 'Generating…',
  delete_confirm: 'Delete this play?', deleted: 'Deleted',
  pdf_generated: 'PDF generated', image_downloaded: 'Image downloaded',
  frames_not_ready: 'Frames not ready, try again',
  share_error: 'Share error', image_export_error: 'Image export error',
  pdf_export_error: 'PDF export error', prediction_error: 'AI prediction error',
  feedback_success_yes: 'Marked as successful', feedback_success_no: 'Marked as failed',
  feedback_error: 'Feedback error', translation_error: 'Translation error',
  cached_translation: 'Cached translation', translated_by_ai: 'Translated by AI',
  translated_to: 'Translated to', translate_with_ai: 'Translate with AI',
  whatsapp_open_attach: 'WhatsApp opened: attach the downloaded image',
  reviews_title: 'Reviews', your_review: 'Your review', publish_review: 'Publish review',
  update_review: 'Update',
  review_placeholder: 'Optional: tell other coaches what you thought...',
  only_buyers_review: 'Only coaches who purchased can review.',
  no_reviews_yet: 'No reviews yet. Be the first.',
  choose_star: 'Choose at least 1 star', review_sent: 'Review sent',
  must_buy_review: 'You must purchase this play to review it',
  review_singular: 'review', review_plural: 'reviews',
  editor_title: 'Play Creator Pro',
  editor_subtitle: 'Works with touch stylus, finger and mouse. Select "Free pencil" to draw.',
  blank_board: 'Blank board', templates: 'Templates', preview_label: 'Preview',
  play_name: 'Name', play_description: 'Description',
  category: 'Category', difficulty: 'Difficulty',
  beginner: 'Beginner', intermediate: 'Intermediate', advanced: 'Advanced',
  pencil_free: 'Free pencil',
  add_offense: '+Offense', add_defense: '+Defense',
  steps_title: 'Steps', add_step: 'Add', step_description: 'Step description',
  speed: 'Speed', delay_exit: '⏱ Exit delay',
  assign_player_circle: 'Assign a player to this token',
  quick_player_selection: 'Quick player selection',
  animation_preview: 'Animation preview',
  load_template_title: 'Load template',
  export_pdf_title: 'Export to PDF',
  export_png_title: 'Download as image',
  share_whatsapp_title: 'Share via WhatsApp',
  clear_text: 'Clear', unassigned: 'Unassigned',
  double_click_assign: 'Double-click on a token to open this selector. Photo + number + name will show on the token.',
  route_timing: 'Route timing',
  route_timing_desc: 'Speed and delay per player to choreograph pick&roll, back-door, double screen…',
  my_roster_quick: 'My roster — quick tap',
  players_count: 'players',
  no_roster_yet_label: 'No players yet. Add them in',
  no_roster_yet_label_after: 'for quick selection.',
  quick_add_hint: 'Tap a player and they appear instantly on court. Double-tap a token to reassign.',
  on_court_badge: 'ON COURT', tips_label: 'Tips',
  tip_offense_defense_a: 'tap the court to add a generic token.',
  tip_pencil_a: 'draw the',
  tip_pencil_b: 'player route',
  tip_pencil_c: 'starting from their token and the system will add the next step. Loose curves (not near a player) remain as annotation.',
  tip_double_tap: 'Double-tap any token to reassign it to a roster player.',
  no_name: 'Untitled', my_new_play: 'My new play', step_default_desc: 'Step',
  move_players: 'Move players', arrow_move: 'Movement arrow',
  pass_tool: 'Pass', dribble_tool: 'Dribble', screen_tool: 'Screen', eraser_tool: 'Erase',
  saved_ok: 'Saved', save_error_msg: 'Save error',
  ai_hero_title: "Hi, I'm your AI Coach",
  ai_hero_subtitle: 'Ask me for plays, optimizations, predictions or strategies.',
  ai_powered_by: 'Powered by PlayMaster IA',
  ai_quick_1_label: 'Create a play against 2-3 zone',
  ai_quick_2_label: 'Recommend ATO plays vs man',
  ai_quick_3_label: 'Optimize Horns Flare',
  ai_quick_1_prompt: 'Design a new play to attack a 2-3 zone defense. Explain the 3 key steps and why it works.',
  ai_quick_2_prompt: 'Recommend the 3 best ATO (after time-out) plays against man defense. Justify.',
  ai_quick_3_prompt: 'I have the Horns Flare play. How can I optimize the spacing and screen angles to make it more lethal against switches?',
  ai_connection_error: 'AI connection error',
  academy_title: 'Academy',
  academy_subtitle: 'Tactical concepts, game reading and fundamentals. Tap a lesson to see curated YouTube tutorials.',
  academy_will_open_youtube: "We'll open YouTube with curated tutorials on this topic.",
  academy_watch_youtube: 'Watch tutorials on YouTube',
  academy_coming_soon: 'Coming soon: native lessons recorded by elite coaches.',
  academy_lesson_1_title: 'Spacing: how to open the court',
  academy_lesson_2_title: 'How to attack the 2-3 zone',
  academy_lesson_3_title: 'Defending the Pick & Roll: drop coverage vs switch',
  academy_lesson_4_title: 'Game reading: when to change tempo',
  academy_lesson_5_title: 'Running the Horns Action',
  academy_lesson_6_title: 'BLOBs and SLOBs in clutch moments',
  academy_cat_fundamentals: 'Fundamentals',
  academy_cat_vs_zone: 'Vs Zone',
  academy_cat_defense: 'Defense',
  academy_cat_iq: 'IQ',
  academy_cat_systems: 'Systems',
  academy_cat_ato_blob: 'ATO/BLOB',
  pricing_h1: 'Level up your game', pricing_subtitle: 'Choose the plan that fits your coaching.',
  plan_most_popular: 'Most popular', payments_mocked: 'MOCKED · Payments will be integrated with Stripe in the next version.',
  payments_secure: 'Payments securely processed by Stripe.',
  pay_current_plan: 'Current plan', pay_active: 'Active', pay_expires_on: 'Expires on',
  pay_redirecting: 'Redirecting…', pay_cancelled: 'Payment cancelled. Retry whenever you want.',
  pay_no_session: 'Payment session not found.',
  pay_verifying: 'Verifying payment…', pay_verifying_sub: 'This will only take a few seconds.',
  pay_thanks_tag: 'THANK YOU', pay_success_title: 'Subscription activated!',
  pay_success_plan: 'Plan', pay_go_dashboard: 'Go to dashboard',
  pay_expired_title: 'Session expired', pay_expired_sub: 'The payment session expired. Try again to continue.',
  pay_timeout_title: 'Verification pending', pay_timeout_sub: "We're confirming with Stripe. Check your email — your plan will be activated once confirmed.",
  pay_error_title: 'Payment error', pay_back_pricing: 'Back to plans',
  stop_edit: 'Back to edit',
  nav_teams: 'Teams', teams_h1: 'My Teams',
  teams_subtitle: 'Manage one or many teams. Each team has its own roster and applies across the editor, playbook and communication.',
  teams_empty: 'You have no teams yet. Create your first one above.',
  team_create: 'Create team', team_create_first: 'Create team',
  team_name: 'Team name', team_name_placeholder: 'e.g. Wolves U18',
  team_category: 'Category', team_cat_male: 'Male', team_cat_female: 'Female', team_cat_mixed: 'Mixed',
  team_created: 'Team created', team_updated: 'Team updated', team_deleted: 'Team deleted',
  team_delete_confirm: 'Delete team "{name}"? Players will be moved to the next available team.',
  team_active: 'Active', team_already_active: 'Active team', team_set_active: 'Activate',
  team_none: 'No team', team_manage: 'Manage teams',
  team_using: 'Using team',
  roster_status_filter: 'Filter',
  roster_status_active: 'Active', roster_status_blocked: 'Blocked',
  roster_status_archived: 'Archived', roster_status_all: 'All',
  roster_archive_confirm: 'Archive this player? They will be hidden but can be reactivated anytime.',
  roster_player_archived: 'Player archived',
  roster_player_reactivated: 'Player reactivated',
  roster_archive_title: 'Archive', roster_reactivate: 'Reactivate',
  nav_assignments: 'Tasks', assignments_h1: 'Weekly Tasks',
  assignments_empty: 'No tasks assigned to this team yet.',
  assign_create: 'Create task', assign_edit: 'Edit task',
  assign_title: 'Title', assign_title_placeholder: 'e.g. Weekly review',
  assign_due: 'Due', assign_notes: 'Notes (optional)',
  assign_notes_placeholder: 'Instructions for players',
  assign_select_plays: 'Select the plays', assign_no_plays: 'No plays available',
  assign_created: 'Task created', assign_updated: 'Task updated', assign_deleted: 'Task deleted',
  assign_delete_confirm: 'Delete this task?', assign_overdue: 'OVERDUE', plays: 'plays',
  invite_team: 'Team', invite_team_none: 'No team assigned',
  nav_study: 'Study', study_h1: 'Study Tracking',
  study_empty: 'No study activity on this team yet.',
  study_player: 'Player', study_time: 'Time', study_viewed: 'Plays viewed',
  study_completed: 'Completed', study_progress: 'Avg progress', study_last_seen: 'Last activity',
  nav_groups: 'Groups', groups_h1: 'Team Groups',
  groups_empty: 'No groups yet', group_name_placeholder: 'Group name',
  group_created: 'Group created', group_deleted: 'Group deleted',
  group_delete_confirm: 'Delete this group and all its messages?',
  group_select: 'Select a group to see messages',
  group_no_messages: 'No messages yet',
  group_message_placeholder: 'Type a message…',
  nav_notes: 'Notes', notes_h1: 'Private notes',
  notes_subtitle: '1:1 conversation with your players.',
  notes_empty_inbox: 'No conversations yet',
  notes_select_conv: 'Select a conversation',
  notes_no_messages: 'No messages yet',
  notes_message_placeholder: 'Type a message…',
  notes_new: 'New message',
  notes_pick_player: 'Player',
  notes_no_registered_players: 'This team has no registered players yet. Invite them from Roster to send them notes.',
  notes_all_teams: 'All my teams',
  nav_board: 'Drawing board',
  dash_this_week: 'This week', dash_upcoming_tasks: 'active tasks',
  dash_study_focus: "Team study", dash_inactive_players: 'inactive players',
  dash_no_study_yet: 'No data yet', dash_inbox: 'Notes inbox',
  dash_unread: 'unread messages',
  player_unread_notes: 'Unread notes', player_team_announcements: 'Team announcements',
  player_my_tasks: 'My tasks this week', player_your_coach: 'Your coach',
  player_message_coach: 'Message coach', player_coach_plays: 'coach plays',
  player_coach_plays_title: "My coach's plays", player_global_sample: 'Global Playbook (sample)',
  my_team: 'My Team', hello_greeting: 'Hi',
  view: 'View', view_all: 'View all', study: 'Study', search: 'Search',
  play_part_of_task: 'This play is part of your task',
  play_ask_about: 'Ask the coach about this play',
  roster_send_note: 'Send note',
  msg_attach_play: 'Attach play',
  team_choose: 'Choose team', assign_team: 'Team',
  roster_invite_btn: 'Invite', roster_invite_title: 'Invite to register',
  roster_invite_copied: 'Link copied to clipboard',
  roster_invite_created: 'Invitation created',
  study_all_teams_subtitle: 'Global view of all your teams and players.',
  study_players_count: 'players',
  study_team_empty: 'No activity on this team yet',
  feat_playbook_full: 'Full playbook (100 plays)',
  feat_advanced_editor: 'Advanced editor',
  feat_unlimited_roster: 'Unlimited roster',
  feat_50_ai: '50 AI sessions/month',
  feat_unlimited_invites: 'Unlimited invitations',
  feat_global_plays: 'Access to global plays',
  feat_didactic_photos: 'Didactic view with your photos',
  feat_personal_ai_coach: 'Personal AI Coach',
  feat_individual_stats: 'Individual stats',
  feat_academy_mode: 'Academy mode',
  feat_100_players: 'Up to 100 players',
  feat_multi_coach: 'Multi-coach',
  feat_unlimited_ai: 'Unlimited AI',
  feat_personal_branding: 'Personal branding',
  feat_priority_support: 'Priority support',
  live_h1: 'Live Game Mode',
  live_subtitle: 'Select the rival defense and moment; the AI recommends 3 plays.',
  live_voice_on: 'Voice on — Game Mode', live_voice_off: 'Turn voice narration on',
  live_voice_extra: 'Each play will be read aloud step by step.',
  live_defense_label: 'Defense:', live_moment_label: 'Moment:',
  live_justification: 'AI Justification', live_see_detail: 'See detail',
  def_man: 'vs Man', def_zone_2_3: 'vs Zone 2-3', def_zone_3_2: 'vs Zone 3-2',
  def_zone_1_3_1: 'vs Zone 1-3-1', def_switch: 'vs Switch', def_press: 'vs Press',
  moment_half_court: 'Half-court', moment_ato: 'After Time-out (ATO)',
  moment_blob: 'BLOB (Baseline)', moment_slob: 'SLOB (Sideline)', moment_endgame: 'End of game',
  marketplace_seller_blurb: 'you keep 85% of each sale. Price: $0.99 – $99.99.',
  profile_eyebrow: 'Profile', profile_h1: 'My Coach Profile',
  profile_player_h1: 'My Player Profile',
  profile_player_subtitle: "Your coach sees the same info in the team Roster.",
  profile_player_photo_help: 'Your photo will appear on the playbook board when your coach assigns you to a play.',
  elite_verified_badge: 'Verified Elite Coach', identity_section: 'Identity',
  no_photo: 'NO PHOTO', upload_photo_btn: 'Upload photo',
  photo_help: 'Your photo and credentials are the first thing buyers will see. Be professional.',
  field_display_name: 'Public name', field_team: 'Team', field_country: 'Country',
  field_credentials: 'Credentials (e.g. Head Coach · 10 years · ACB League)',
  field_twitter: 'Twitter / X (@username)', field_instagram: 'Instagram (@username)',
  field_website: 'Website', field_bio: 'Bio (tell the community what kind of coach you are)',
  save_profile_btn: 'Save profile', elite_status: 'Elite Status',
  verified_state: 'VERIFIED',
  elite_active_text: 'Your account is elite. Your plays are visible in the Marketplace.',
  elite_since: 'Since:', view_my_store: 'View my store',
  not_elite_yet: "You're not an Elite Coach yet. Request verification to sell plays in the Marketplace.",
  requirements_label: 'Requirements:',
  req_bio_photo: 'Bio + professional photo', req_credentials: 'Verifiable credentials',
  req_5_plays: 'Min. 5 own plays created',
  request_verification: 'Request verification (admin only in v1)',
  my_achievements: 'My Achievements', no_achievements: "You haven't unlocked any achievements yet.",
  publish_in_marketplace: 'Publish to Marketplace',
  unpublish_from_marketplace: 'Remove from Marketplace',
  photo_uploaded: 'Photo uploaded', upload_error: 'Upload error',
  profile_saved: 'Profile saved', play_published: 'Play published to marketplace',
  play_unpublished: 'Removed from marketplace',
  price_prompt: 'Price (USD, between 0.99 and 99.99)',
  sale_blurb_prompt: 'Short sale description:', purchased_badge: '(Purchased)',
  landing_get_started: 'Get started', landing_install_app: 'Install app',
  landing_hero_subtitle: 'The first smart playbook designed for basketball coaches. Design, simulate and share plays with AI.',
  landing_feature_editor: 'Visual editor', landing_feature_editor_desc: 'Draw tactile plays with finger or stylus. Automatic animations.',
  landing_feature_ai: 'AI Coach', landing_feature_ai_desc: 'Generate plays, recommend against any defense, predict success.',
  landing_feature_share: 'Easy sharing', landing_feature_share_desc: 'Export PDF, share via WhatsApp with real animations.',
  landing_install_short: 'Install',
  landing_hero_h1_a: 'The Future of', landing_hero_h1_b: 'Basketball Playbooks',
  landing_hero_h2: 'The #1 AI Basketball Playbook for Coaches and Players',
  landing_hero_para: 'PlayMaster IA is redefining the future of basketball playbooks with the most advanced AI-powered coaching ecosystem. Create, teach, and run elite basketball plays using a visual editor with real photos, a growing library of professional plays, generative & predictive AI, roster management, invitations, and a complete development system for teams and academies.',
  landing_hero_para_2: 'Designed for youth basketball, high school, AAU, academies, and pro-level coaching, PlayMaster IA combines modern technology with real basketball strategy to help coaches and players think faster, play smarter, and win more.',
  landing_stat_plays: 'Plays', landing_stat_languages: 'Languages', landing_stat_coach_24: 'Coach 24/7',
  landing_live_preview: 'Live preview',
  landing_cap_eyebrow: 'Capabilities',
  landing_cap_h1_a: 'A complete ecosystem', landing_cap_h1_b: 'for elite basketball',
  landing_f_playbook_t: 'Global Playbook', landing_f_playbook_d: 'Over 117 professional plays — and growing — classified by Man, Zone, ATO, BLOB, SLOB, and End-of-Game, all with step-by-step animations and a didactic structure.',
  landing_f_ai_t: 'AI Coach', landing_f_ai_d: 'The AI generates new plays, optimizes existing ones and predicts the probability of success. It also recommends plays in real time during games.',
  landing_f_roster_t: 'Roster with Photos', landing_f_roster_d: 'Upload real photos and build complete player profiles. Drag your players directly onto the court for 100% didactic and personalized plays.',
  landing_f_langs_t: '3 Languages', landing_f_langs_d: 'Available in Spanish, English and French, with AI narration, auto-translation and didactic enrichment.',
  landing_f_live_t: 'Live Game Mode', landing_f_live_d: 'Select the opposing defense and the moment of the game; the AI recommends 3 instant plays with tactical explanation.',
  landing_f_editor_t: 'Visual Editor', landing_f_editor_d: 'NBA-style court, floating tools, movement drawing, screens, cuts and multi-step plays. The most intuitive and powerful editor in modern basketball.',
  landing_cta_h1: 'Ready to revolutionize your whiteboard?', landing_cta_demo: 'Coach demo:',
  landing_cta_btn: 'Start for free', contact: 'Contact',
  achievements_eyebrow: 'Achievements', achievements_h1: 'My Achievements',
  achievements_subtitle_a: 'Unlock badges by using the app.', achievements_subtitle_b: 'unlocked.',
  achievements_progress: 'Progress', achievements_latest: 'Latest unlocked achievements',
  achievements_no_data: 'No data.', achievements_no_yet: 'Start using the app!',
  cat_creation: 'Creation', cat_roster_t: 'Roster', cat_sales: 'Marketplace (Seller)',
  cat_buying: 'Marketplace (Buyer)', cat_quality: 'Quality', cat_status: 'Status', cat_ai: 'AI',
  tier_bronze: 'BRONZE', tier_silver: 'SILVER', tier_gold: 'GOLD', tier_elite: 'ELITE',
  no_badges_yet: 'No achievements yet.',
  notifications_eyebrow: 'Notifications', notifications_h1: 'Notification center',
  notif_enable_push: 'Enable Push', notif_test: 'Test', notif_disable_push: 'Disable push',
  notif_mark_all: 'Mark all', notif_empty: 'No notifications yet.',
  notif_marked_all: 'All marked as read',
  notif_push_on: 'Push enabled. We will notify you even if you close the app.',
  notif_push_off: 'Push disabled', notif_push_error: 'Could not enable',
  notif_test_sent: 'Test push sent', notif_test_error: 'Error sending test',
  devices: 'device', devices_plural: 'devices',
  market_h1: 'Elite Playbooks',
  market_subtitle: 'Buy plays created by verified coaches. Each purchase is a personal copy added to your playbook.',
  market_publish_my_play: 'Publish my play',
  market_publish_my_play_title: 'Publish your play in the marketplace',
  market_banner_title: 'Are you a coach? Share and sell your system',
  market_banner_body: 'Publish your plays with animation, routes and speeds. Set your price between $0.99 and $99.99. You keep 85% of each sale.',
  market_banner_start: 'Get started →',
  market_tab_listings: 'Plays for sale',
  market_tab_coaches: 'Elite Coaches',
  market_tab_leaderboard: 'Ranking · Coach of the Month',
  market_sort_popular: 'Popular',
  market_sort_recent: 'Recent',
  market_sort_price_asc: 'Price ↑',
  market_sort_price_desc: 'Price ↓',
  market_cat_all: 'All',
  market_empty: 'No plays for sale in this category yet.',
  market_sales: 'sales',
  market_success: 'success',
  market_students: 'students',
  market_plays_count: 'plays',
  market_verified_elite: 'Verified Elite',
  roster_h1: 'Roster',
  roster_player_updated: 'Player updated',
  roster_player_added: 'Player added',
  roster_save_error: 'Save error',
  roster_delete_confirm: 'Delete player? (They will be permanently removed from the team.)',
  roster_block_confirm: 'Block this player? They will no longer be part of the team and will not see your plays.',
  roster_unblock_confirm: 'Unblock this player? They will regain access to your plays.',
  roster_player_unblocked: 'Player unblocked',
  roster_player_blocked: 'Player blocked',
  roster_action_error: 'Action failed',
  roster_no_players: "You don't have any players yet. Tap",
  roster_camera_title: 'Take photo with camera',
  roster_upload_gallery_title: 'Upload from gallery',
  roster_camera_btn: 'Camera',
  roster_upload_btn: 'Upload',
  roster_photo_uploaded: 'Photo uploaded',
  roster_photo_upload_error: 'Photo upload error',
  roster_blocked_badge: 'Blocked',
  roster_block_btn: 'Block',
  roster_unblock_btn: 'Reactivate',
  roster_delete_title: 'Remove permanently',
  roster_block_title: 'Block and remove from team',
  roster_unblock_title: 'Unblock',
  roster_no_photo: 'NO PHOTO',
  roster_hand_right: 'Right',
  roster_hand_left: 'Left',
  roster_hand_ambi: 'Ambidextrous',
  roster_hand_letter_right: 'R',
  roster_hand_letter_left: 'L',
  roster_hand_letter_ambi: 'A',
  roster_player_in_court: 'is already on the court',
  roster_player_added_to_court: 'added',
  // Universal join panel
  ujp_eyebrow: 'Team universal link',
  ujp_title: 'One link for all your players',
  ujp_subtitle: 'Share it once. Any player who opens it picks a team + PIN and lands in your roster.',
  ujp_active: 'Active',
  ujp_paused: 'Paused',
  ujp_copy: 'Copy',
  ujp_share: 'Share',
  ujp_view: 'View',
  ujp_view_as_player_title: 'Open as a player would see it',
  ujp_pin_section_title: 'Per-team PIN (optional anti-spam)',
  ujp_active_tag: 'active',
  ujp_pin_placeholder: '4-8 digits',
  ujp_no_pin: '— no PIN —',
  ujp_change: 'Change',
  ujp_add: 'Add',
  ujp_remove: 'Remove',
  ujp_remove_pin_title: 'Remove PIN',
  ujp_footer: 'Without PIN: anyone with the link can join. With PIN: the player must enter it to join that team.',
  ujp_link_copied: 'Link copied',
  ujp_copy_failed: 'Could not copy',
  ujp_share_native_title: 'Join my team on PlayMaster IA',
  ujp_share_native_text: 'Sign up as a player with this unique link:',
  ujp_link_activated: 'Link activated',
  ujp_link_paused: 'Link paused',
  ujp_link_update_error: 'Could not update',
  ujp_pin_saved: 'PIN saved',
  ujp_pin_removed: 'PIN removed',
  ujp_pin_save_error: 'Could not save PIN',
  // Share invite button
  sib_default_title: 'PlayMaster IA Invitation',
  sib_default_text: "I'm inviting you to join my team on PlayMaster IA. Sign up here:",
  sib_native_error: 'Could not open native share',
  sib_link_copied: 'Link copied',
  sib_copy_failed: 'Could not copy',
  sib_share: 'Share',
  sib_share_title: 'Share invitation',
  sib_copied: 'Copied',
  sib_copy_link: 'Copy link',
  // Invite QR button
  qrb_default_label: 'Invitation',
  qrb_download_failed: 'Could not download',
  qrb_show_qr_title: 'Show QR to scan',
  qrb_close: 'Close',
  qrb_scan_to_join: 'Scan to join',
  qrb_download_png: 'Download PNG',
  admin_h1: 'Admin Panel',
  admin_tab_overview: 'Dashboard',
  admin_tab_users: 'Users',
  admin_tab_activity: 'Activity',
  admin_coaches: 'Coaches',
  admin_players: 'Players',
  admin_plays_global: 'Global plays',
  admin_ai_sessions: 'AI sessions',
  admin_top_plays: 'Top plays',
  admin_by_category: 'By category',
  admin_col_name: 'Name',
  admin_col_email: 'Email',
  admin_col_role: 'Role',
  admin_col_created: 'Created',
  admin_delete_user_confirm: 'Delete user?',
  admin_recent_activity: 'Recent activity',
  admin_tab_maintenance: 'Maintenance',
  admin_backfill_title: 'Backfill enrichment (every active language)',
  admin_backfill_body: 'Run ONCE to enrich every play in each active language (ES/EN/FR). Already-enriched combinations are skipped — re-running is free. New plays are auto-enriched on creation.',
  admin_active_langs: 'Active languages',
  offline_no_connection: 'Offline',
  offline_pending: 'pending',
  offline_syncing: 'Syncing…',
  offline_synced: 'Synced',
  offline_cached_session: 'Cached session (offline)',
  offline_play_unavailable: 'This play is not downloaded. Connect to view it.',
  offline_saved_locally: 'Saved locally — will sync when back online',
  tablet_mode: 'Fullscreen',
  tablet_mode_title: 'Tablet fullscreen — ideal for showing the play during a game or timeout',
  present_mode: 'Expand',
  present_mode_title: 'Presentation mode: court locked fullscreen — no accidental finger/stylus movement',
  present_mode_exit: 'Close',
  sim_back_to_play: 'Back to play',
  sim_eyebrow: 'Tactical Simulator',
  sim_subtitle: 'The AI will simulate the defensive reaction and suggest concrete adjustments.',
  sim_rival_defense: 'Rival defense',
  sim_exec_level: 'Execution level',
  sim_run_now: 'Simulate now',
  sim_running: 'Simulating...',
  sim_ai_prediction: 'AI Prediction',
  sim_confidence: 'Confidence:',
  sim_def_reaction: 'How the defense would react',
  sim_failure_points: 'Where it would fail',
  sim_adjustments: 'Recommended adjustments',
  sim_key_player: 'Player #1:',
  tpl_modal_eyebrow: 'Templates',
  tpl_modal_title: 'Start with a proven system',
  tpl_modal_subtitle: 'Pre-loaded plays with calibrated speeds and delays. Tweak to your taste.',
  tpl_steps_count: 'steps',
  diff_basic: 'Basic',
  diff_medium: 'Medium',
  diff_advanced: 'Advanced',
  editor_add_defenders: 'Add defenders',
  editor_add_defenders_title: 'Place 5 defenders in man-to-man formation',
  editor_defenders_added: '5 defenders added',
  editor_defenders_already: 'Defenders are already on the court',
  editor_remove_defenders: 'Remove defense',
  editor_remove_defenders_title: 'Remove the 5 defenders from this step',
  editor_defenders_removed: 'Defense removed',
  enrich_play: '✨ Enrich narration',
  regenerate_enrichment: '✨ Regenerate narration',
  enriching: 'Enriching...',
  enrichment_success: 'Play enriched — the voice and texts are now more didactic',
  enrichment_error: 'Error enriching the play',
  enrichment_hint: 'AI generates longer, didactic explanations (What + Why + Key cue) for each step. The narration will read the enriched text.',
  bulk_enrich_section_title: 'Bulk Enrichment',
  bulk_enrich_section_body: 'Enrich ALL your plays at once in the current language. The AI generates didactic narrations (What + Why + Key cue) that your players will hear when each play runs. Runs in the background — you can close this window, progress is preserved.',
  bulk_enrich_btn: '🚀 Enrich all my plays',
  bulk_enrich_running: 'Enriching',
  bulk_enrich_hint: 'Generates enriched narrations for every play you own in the current language.',
  bulk_enrich_force_label: 'Force regenerate (also already-enriched ones)',
  bulk_enrich_in_progress: 'Enriching plays',
  bulk_enrich_done: 'Enrichment complete!',
  bulk_enrich_done_title: 'Done',
  bulk_enrich_start_error: 'Failed to start enrichment',
  bulk_enrich_completed: 'Completed',
  bulk_enrich_skipped: 'Skipped (already enriched)',
  bulk_enrich_failed: 'Failed',
  bulk_enrich_current: 'Now processing',
  bulk_enrich_errors: 'Errors',
  bulk_enrich_background_note: 'This may take several minutes depending on how many plays you have. You can close this window — the process continues in the background.',

  // ── Public-facing surfaces (Plays Hub, Coach Profiles) — i18n batch 2026-02-25 ─────
  ph_counter_label: 'PLAYBOOK',
  ph_counter_word: 'PLAYS',
  ph_tagline: 'Public basketball playbook · diagrams, variations and tactical context. A new one every day.',
  ph_training_pill_prefix: 'Training with',
  ph_training_pill_suffix: 'shots from real coaches',
  ph_filter_all: 'All',
  ph_sort_label: 'Sort:',
  ph_sort_recent: 'Recent',
  ph_sort_popular: 'Popular',
  ph_sort_trending: 'Trending',
  ph_nav_blog: 'Blog',
  ph_nav_login: 'Login',
  ph_nav_signup: 'Sign up',
  ph_nav_jugadas: 'Plays',
  ph_nav_coaches: 'Coaches',

  // Coach profile + directory
  cp_label_coach: 'COACH',
  cp_label_directory: 'DIRECTORY',
  cp_loading: 'Loading...',
  cp_404_title: 'Coach not found',
  cp_404_body: 'This profile does not exist or is not public.',
  cp_back_to_plays: 'Back to plays',
  cp_his_plays: 'Their plays',
  cp_no_plays_yet: "Hasn't published any plays yet.",
  cp_stat_plays: 'Plays',
  cp_stat_likes: 'Likes',
  cp_stat_views: 'Views',
  cp_stat_verified: 'Verified',
  cp_dir_coaches_label: 'Coaches',
  cp_dir_tagline: "Public community of coaches sharing their best plays. Discover real tactical philosophies.",
  cp_dir_loading: 'Loading coaches...',
  cp_dir_empty: 'Are you a coach? Enable your public profile from your account to appear here.',
  cp_seo_default_desc: '{name} shares {count} basketball plays on PlayMaster IA.',
  cp_seo_dir_desc: 'Public directory of basketball coaches on PlayMaster IA. Discover coaches, their plays and tactical philosophy.',

  // Public profile editor (inside /profile)
  ppe_title: 'Public profile',
  ppe_subtitle: 'Turn on your public page. Indexable by Google. Great for portfolio and receiving invitations.',
  ppe_public: 'PUBLIC',
  ppe_private: 'PRIVATE',
  ppe_your_url: 'Your URL:',
  ppe_copy: 'copy',
  ppe_open: 'open',
  ppe_copied: 'Copied',
  ppe_slug: 'Slug',
  ppe_country: 'Country',
  ppe_country_placeholder: 'United States',
  ppe_bio: 'Bio (max 600)',
  ppe_bio_placeholder: 'Tell the community about your tactical philosophy.',
  ppe_twitter: 'Twitter (no @)',
  ppe_instagram: 'Instagram (no @)',
  ppe_website: 'Website',
  ppe_website_placeholder: 'https://your-academy.com',
  ppe_save: 'Save changes',
  ppe_saving: 'Saving...',
  ppe_save_success: 'Profile updated',
  ppe_save_error: 'Could not save',
  ph_empty_state: 'No plays published in this category yet. Check back tomorrow.',
  ph_loading_more: 'Loading...',
  ph_load_more: 'Load more',
  ph_footer_privacy: 'Privacy',
  ph_footer_terms: 'Terms',
  landing_f_iqsim_t: 'Game IQ Simulator',
  landing_f_iqsim_d: 'Test your players\' tactical reading with AI-generated real scenarios. Instant grading, coach explanation, and measurable progress.',
  landing_f_iqscore_t: 'IQ Score',
  landing_f_iqscore_d: 'Official basketball IQ rating per player. Team ranking, historical evolution, and roster comparisons.',
  landing_f_shot_t: 'Shot Analyzer',
  landing_f_shot_d: 'Analyze shooting mechanics with computer vision. Rim detection, ball trajectory, biomechanics, and per-player shot heat maps.',
  nav_group_dashboard: 'Dashboard',
  nav_group_roster: 'Roster',
  nav_group_ai: 'AI Coach',
  nav_group_marketplace: 'Marketplace',
  nav_group_profile: 'My Profile',
  nav_board: 'Drawing Board',
  // ── Editor Easy mode (visible UI strings) — i18n batch 2026-02-25 ───
  ee_action_pass: 'Pass',
  ee_action_dribble: 'Dribble',
  ee_action_move: 'Move',
  ee_action_cut: 'Cut',
  ee_action_screen: 'Screen',
  ee_action_block: 'Block',
  ee_action_handoff: 'Handoff',
  ee_action_shot: 'Shot',
  ee_toast_defense_on: 'Defense mode',
  ee_toast_offense_on: 'Offense mode',
  ee_toast_full_court: 'Full court',
  ee_toast_half_court: 'Half court',
  ee_toast_clean: 'Court cleared',
  ee_toast_no_teammates: 'No teammates',
  ee_toast_no_blockers: 'No teammates to block for',
  ee_toast_add_defense_first: 'Add defense first',
  ee_toast_add_offense_first: 'Add offense first',
  ee_toast_move_outside_arc: 'Move outside the arc first',
  ee_toast_save_failed: 'Could not save',
  ee_play_defensive: 'Defensive play',
  ee_tooltip_fullscreen: 'Fullscreen',
  ee_tooltip_exit_fullscreen: 'Exit fullscreen',
  ee_tooltip_category_default: 'Default category (edit the name to classify)',
  ee_tooltip_category_detected: 'Category detected from name',
  ee_btn_remove_defense: 'Remove defense',
  ee_btn_remove_offense: 'Remove offense',
  ee_court_half: 'Half',
  ee_court_full: 'Full',
  ee_team_offense: 'Offense',
  ee_team_defense: 'Defense',
  ee_tooltip_advanced_mode: 'Advanced mode with all tools',
  ee_tooltip_exit_editor: 'Exit editor',
  ee_tooltip_edit_name: 'Edit play name',
  ee_draw_instruction: 'Drag a player to draw their movement',
  ee_btn_add_defense: 'Add defense',
  ee_btn_add_offense: 'Add offense',
  ee_btn_clear: 'Clear',
  ee_btn_save: 'Save',
  ee_btn_saved: 'Saved',
  ee_tooltip_drag_first: 'Drag a player first',
  ee_tooltip_save_play: 'Save play',
  ee_toast_saved_offline: 'Saved (offline)',
  ee_default_play_name: 'Play',
  ee_label_attack: 'ATTACK',
  ee_label_defense: 'DEFENSE',
  ph_cta_title: 'Unlock the complete playbook library',
  ph_cta_subtitle: "You're seeing only a preview. Sign up free to access the step-by-step diagram, variations, and tactical logic for every play.",
  ph_cta_button: 'Create free account',
};

export default dict;
